import { Td, Tr } from '@aloft/toolkit-sui';

import {
  selectDepreciation,
  selectExternalDepreciation,
  selectFunctionalDepreciation,
  selectPhysicalDepreciation,
} from '../../../redux/features/selectors/depreciationSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { getCostString } from '../utils/getCostString.ts';

export const DepreciationContentRow = () => {
  const physical = useAppSelector((state) => selectPhysicalDepreciation(state, 'subject'));
  const functional = useAppSelector((state) => selectFunctionalDepreciation(state, 'subject'));
  const external = useAppSelector((state) => selectExternalDepreciation(state, 'subject'));
  const total = useAppSelector((state) => selectDepreciation(state, 'subject'));

  return (
    <Tr>
      <Td>Depreciation</Td>
      <Td colSpan={2}>{physical?.toString(true)}</Td>
      <Td colSpan={2}>{functional?.toString(true)}</Td>
      <Td colSpan={2}>{external?.toString(true)}</Td>
      <Td className="cost-approach-table-align-right">{getCostString(total)}</Td>
    </Tr>
  );
};
